<script setup lang="ts"></script>

<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="11" height="8" viewBox="0 0 11 8" fill="none">
    <path
      d="M1.08334 3.99967L3.9275 6.91634L9.41668 1.08301"
      fill="none"
      stroke="currentColor"
      stroke-width="2.16667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
